document.addEventListener('DOMContentLoaded', () => {

  /* ------------------ FEATURES SLIDER ------------------ */
  document.querySelectorAll('[data-d367]').forEach(wrapper => {
    if (wrapper.dataset.init) return;
    wrapper.dataset.init = 'true';

    const slider = wrapper.querySelector('.d367-features');
    const prev = wrapper.querySelector('.d367-arrow.left');
    const next = wrapper.querySelector('.d367-arrow.right');
    if (!slider || !prev || !next) return;

    const card = slider.querySelector('.d367-feature');
    const scrollAmount = card ? card.offsetWidth + 12 : 260;

    const updateArrows = () => {
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      prev.style.display = slider.scrollLeft > 5 ? 'flex' : 'none';
      next.style.display = slider.scrollLeft < maxScroll - 5 ? 'flex' : 'none';
    };

    updateArrows();

    prev.addEventListener('click', () =>
      slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' })
    );

    next.addEventListener('click', () =>
      slider.scrollBy({ left: scrollAmount, behavior: 'smooth' })
    );

    slider.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
  });

  /* ------------------ UNIT PRICE (1.06) ------------------ */
  // (function () {
  //   const variantDataEl = document.querySelector('[data-product-variants]');
  //   if (!variantDataEl) return;

  //   const variants = JSON.parse(variantDataEl.textContent);
  //   const bar = document.querySelector('[data-unit-price]');
  //   const valueEl = document.querySelector('[data-unit-price-value]');
  //   const typeEl = document.querySelector('[data-unit-type]');
  //   if (!bar || !valueEl || !typeEl) return;

  //   function updateUnitPriceByVariantId(variantId) {
  //     const variant = variants.find(v => String(v.id) === String(variantId));
  //     if (!variant || !variant.weight) return;

  //     const unitPrice = (variant.price / 100) / variant.weight;
  //     valueEl.textContent = unitPrice.toFixed(2);
  //     typeEl.textContent = 'gram';
  //     bar.style.display = 'flex';
  //   }

  //   function tryInitialLoad() {
  //     const idInput = document.querySelector('form [name="id"]');
  //     if (idInput?.value) updateUnitPriceByVariantId(idInput.value);
  //   }

  //   setTimeout(tryInitialLoad, 50);
  //   setTimeout(tryInitialLoad, 200);

  //   document.addEventListener('change', e => {
  //     if (!e.target.matches('[data-variant-input]')) return;
  //     const form = e.target.closest('form');
  //     const idInput = form?.querySelector('[name="id"]');
  //     if (idInput?.value) updateUnitPriceByVariantId(idInput.value);
  //   });
  // })();
    
    (function () {

      /* ===============================
        READ VARIANT JSON
      =============================== */
      const variantDataEl = document.querySelector('[data-product-variants]');
      if (!variantDataEl) return;

      const variants = JSON.parse(variantDataEl.textContent);
      // D367 CUSTOM CODE START:
      // Added references for metafield-based default variant selection + unit price UI hooks.
      // No existing code removed at this point.
      const variantPickerRoot = document.querySelector('.product-block.d367-variants');
      const unitPriceBar = document.querySelector('[data-unit-price]');
      const unitPriceValueEl = document.querySelector('[data-unit-price-value]');
      const unitTypeEl = document.querySelector('[data-unit-type]');

      /* ===============================
        MONEY FORMATTER (NO SHOPIFY DEP)
      =============================== */
      function formatMoney(cents) {
        return '₹' + (cents / 100).toFixed(2);
      }

      /* ===============================
        HELPERS
      =============================== */
      // D367 CUSTOM CODE:
      // Normalizes ids from plain numeric strings and gid-like values.
      function normalizeVariantId(rawValue) {
        if (rawValue === null || rawValue === undefined) return '';
        const raw = String(rawValue).trim();
        if (!raw) return '';

        const matches = raw.match(/\d+/g);
        return matches && matches.length ? matches[matches.length - 1] : raw;
      }

      function getVariantById(variantId) {
        const normalizedId = normalizeVariantId(variantId);
        if (!normalizedId) return null;

        return variants.find(v => String(v.id) === normalizedId) || null;
      }

      function getVariantWeightInGrams(variant) {
        const grams = Number(variant?.grams);
        if (Number.isFinite(grams) && grams > 0) return grams;

        const weight = Number(variant?.weight);
        if (!Number.isFinite(weight) || weight <= 0) return 0;

        const weightUnit = String(variant?.weight_unit || 'g').toLowerCase();

        if (weightUnit === 'kg') return weight * 1000;
        if (weightUnit === 'lb') return weight * 453.59237;
        if (weightUnit === 'oz') return weight * 28.349523125;
        if (weightUnit === 'mg') return weight / 1000;

        return weight;
      }

      // D367 CUSTOM CODE:
      // Added/extended unit price update logic to avoid persistent ₹0.00/gram.
      // Existing old unit-price block above remained commented; not deleted by this patch.
      function updateUnitPrice(variant) {
        if (!unitPriceValueEl || !unitPriceElOrBarExists()) return;

        const grams = getVariantWeightInGrams(variant);
        if (!variant || grams <= 0) {
          unitPriceValueEl.textContent = '0.00';
          return;
        }

        const unitPrice = (Number(variant.price) / 100) / grams;
        unitPriceValueEl.textContent = unitPrice.toFixed(2);
      }

      function unitPriceElOrBarExists() {
        return unitPriceBar || unitPriceValueEl || unitTypeEl;
      }

      function getSelectedVariantFromForm() {
        const idInput =
          document.querySelector('form[action^="/cart/add"] [name="id"]') ||
          document.querySelector('form [name="id"]');

        return idInput ? getVariantById(idInput.value) : null;
      }

      function getSelectedVariantFromOptions() {
        const optionGroups = Array.from(document.querySelectorAll('.d367-option-group'));
        if (!optionGroups.length) return null;

        return variants.find(variant =>
          optionGroups.every((group, index) => {
            const selectedInput = group.querySelector('input:checked');
            if (!selectedInput) return true;
            return String(variant.options[index]) === String(selectedInput.value);
          })
        ) || null;
      }

      function triggerVariantChange(variant) {
        document.dispatchEvent(
          new CustomEvent('variant:change', { detail: { variant: variant } })
        );
      }

      function syncVariantIdInputs(variantId) {
        document.querySelectorAll('form [name="id"]').forEach(input => {
          if (String(input.value) === String(variantId)) return;
          input.value = variantId;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      function selectVariantOptions(variant) {
        if (!variant || !Array.isArray(variant.options)) return;

        const optionGroups = Array.from(document.querySelectorAll('.d367-option-group'));
        optionGroups.forEach((group, optionIndex) => {
          const targetValue = variant.options[optionIndex];
          if (targetValue === null || targetValue === undefined) return;

          const targetInput = Array.from(group.querySelectorAll('input[type="radio"]')).find(
            input => String(input.value) === String(targetValue)
          );

          if (!targetInput || targetInput.checked) return;

          targetInput.checked = true;
          targetInput.dispatchEvent(new Event('change', { bubbles: true }));
        });

        syncVariantIdInputs(variant.id);
        updatePackUI();
        updateUnitPrice(variant);
        triggerVariantChange(variant);
      }

      // D367 CUSTOM CODE:
      // Auto-select default variant from metafield-backed data-default-variant-id.
      function applyDefaultVariantSelection() {
        const defaultVariantId = normalizeVariantId(
          variantPickerRoot?.dataset?.defaultVariantId
        );
        if (!defaultVariantId) return null;

        const defaultVariant = getVariantById(defaultVariantId);
        if (!defaultVariant) return null;

        selectVariantOptions(defaultVariant);
        return defaultVariant;
      }

      function getOptionGroupByIndex(optionIndex) {
        return document.querySelector(
          `.d367-option-group .variant-input-wrap[data-index="option${optionIndex}"]`
        )?.closest('.d367-option-group') || null;
      }

      function getSelectedValueFromGroup(group) {
        if (!group) return null;
        const input = group.querySelector('input:checked');
        return input ? input.value : null;
      }

      function findVariant(sizeValue, packValue) {
        return variants.find(v =>
          String(v?.options?.[0]) === String(sizeValue) &&
          String(v?.options?.[1]) === String(packValue)
        ) || null;
      }

      /* ===============================
        UPDATE PACK UI
      =============================== */
      function updatePackUI() {
        const sizeGroup = getOptionGroupByIndex(1);
        const packGroup = getOptionGroupByIndex(2);
        if (!sizeGroup || !packGroup) return;

        const size = getSelectedValueFromGroup(sizeGroup);
        if (!size) return;

        let selectedPackInput = packGroup.querySelector('input:checked');
        let firstVisiblePackInput = null;

        packGroup.querySelectorAll('.variant-input').forEach(packDiv => {
          const packValue = packDiv.getAttribute('data-value');
          const input = packDiv.querySelector('input');
          const label = packDiv.querySelector('label');
          if (!input || !label) return;

          const variant = findVariant(size, packValue);

          if (!variant) {
            packDiv.style.display = 'none';
            input.checked = false;
            return;
          }

          packDiv.style.display = 'block';
          if (!firstVisiblePackInput) firstVisiblePackInput = input;

          const priceEl = label.querySelector('.d367-price');
          if (priceEl) {
            priceEl.innerHTML = formatMoney(variant.price);
          }

          const mrpEl = label.querySelector('.d367-mrp');
          if (mrpEl && variant.compare_at_price) {
            mrpEl.innerHTML = 'MRP: ' + ' ' + '<span>' + formatMoney(variant.compare_at_price) + '</span>';
          }

          const discountEl = label.querySelector('.d367-discount');
          if (discountEl && variant.compare_at_price > variant.price) {
            const discount = Math.round(
              ((variant.compare_at_price - variant.price) * 100) /
              variant.compare_at_price
            );
            discountEl.textContent = discount + '%';
            discountEl.style.display = 'inline-block';
          } else if (discountEl) {
            discountEl.style.display = 'none';
          }
        });

        if (!selectedPackInput || selectedPackInput.closest('.variant-input')?.style.display === 'none') {
          selectedPackInput = firstVisiblePackInput;
          if (selectedPackInput && !selectedPackInput.checked) {
            selectedPackInput.checked = true;
            selectedPackInput.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
        }

        const selectedVariant = getSelectedVariantFromOptions() || getSelectedVariantFromForm();
        if (selectedVariant) {
          syncVariantIdInputs(selectedVariant.id);
          updateUnitPrice(selectedVariant);
          triggerVariantChange(selectedVariant);
        }
      }

      /* ===============================
        EVENTS
      =============================== */
      document.addEventListener('change', e => {
        if (!e.target.matches('.variant-input input')) return;
        updatePackUI();
        setTimeout(() => {
          const selectedVariant = getSelectedVariantFromOptions() || getSelectedVariantFromForm();
          if (selectedVariant) {
            syncVariantIdInputs(selectedVariant.id);
            triggerVariantChange(selectedVariant);
          }
          updateUnitPrice(selectedVariant);
        }, 0);
      });

      // D367 CUSTOM CODE: keep cost/gram in sync with global theme variant events.
      document.addEventListener('variant:change', e => {
        updateUnitPrice(e?.detail?.variant);
      });

      /* ===============================
        INITIAL LOAD
      =============================== */
      // D367 CUSTOM CODE:
      // First try metafield default variant, then fallback to current form/option/first variant.
      const defaultVariant = applyDefaultVariantSelection();

      setTimeout(() => {
        updatePackUI();

        const initialVariant =
          getSelectedVariantFromForm() ||
          getSelectedVariantFromOptions() ||
          defaultVariant ||
          variants[0];

        updateUnitPrice(initialVariant);
      }, 150);
      // D367 CUSTOM CODE END.

    })();


  /* ------------------ REWARD SLIDER ------------------ */
  document.querySelectorAll('[data-d367-reward]').forEach(wrapper => {
    const track = wrapper.querySelector('.d367-reward-features');
    const prev = wrapper.querySelector('.d367-reward-arrow.left');
    const next = wrapper.querySelector('.d367-reward-arrow.right');
    if (!track || !prev || !next) return;

    const updateArrows = () => {
      const max = track.scrollWidth - track.clientWidth;
      if (max <= 5) {
        prev.classList.add('is-hidden');
        next.classList.add('is-hidden');
        return;
      }
      prev.classList.toggle('is-hidden', track.scrollLeft <= 5);
      next.classList.toggle('is-hidden', track.scrollLeft >= max - 5);
    };

    prev.addEventListener('click', () =>
      track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' })
    );

    next.addEventListener('click', () =>
      track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' })
    );

    track.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
    setTimeout(updateArrows, 200);
  });

  /* ------------------ VIDEO PLACEHOLDER ------------------ */
  document.addEventListener('click', e => {
    const btn = e.target.closest('.d367-hero-play-btn');
    if (!btn) return;

    const wrap = btn.closest('.d367-hero-video-wrap');
    const url = wrap?.dataset.videoUrl;
    if (!url) return;

    let media;

    if (url.includes('youtube')) {
      const id = url.split('v=')[1]?.split('&')[0];
      if (!id) return;
      media = document.createElement('iframe');
      media.src = `https://www.youtube.com/embed/${id}?autoplay=1`;
      media.allow = 'autoplay; encrypted-media';
    } else {
      media = document.createElement('video');
      media.src = url;
      media.controls = true;
      media.autoplay = true;
    }

    media.allowFullscreen = true;
    media.style.cssText = 'width:100%;height:100%;border:0;';
    wrap.innerHTML = '';
    wrap.appendChild(media);
  });

  /* ------------------ INGREDIENT SLIDER ------------------ */
  document.querySelectorAll('.d367-ing-wrapper').forEach(wrapper => {
    const track = wrapper.querySelector('.d367-ing-track');
    const prev = wrapper.querySelector('.d367-ing-prev');
    const next = wrapper.querySelector('.d367-ing-next');
    if (!track || !prev || !next) return;

    const step = () => track.clientWidth * 0.85;

    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      if (max <= 5) {
        prev.classList.add('is-hidden');
        next.classList.add('is-hidden');
        return;
      }
      prev.classList.toggle('is-hidden', track.scrollLeft <= 5);
      next.classList.toggle('is-hidden', track.scrollLeft >= max - 5);
    };

    prev.addEventListener('click', () =>
      track.scrollBy({ left: -step(), behavior: 'smooth' })
    );

    next.addEventListener('click', () =>
      track.scrollBy({ left: step(), behavior: 'smooth' })
    );

    track.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    setTimeout(update, 200);
  });


  /* ------------------ VARIANTS SHOWCASE SLIDER ------------------ */
  document.querySelectorAll('[data-d367-showcase-slider]').forEach(slider => {
    const track = slider.querySelector('[data-d367-showcase-track]');
    const dotsWrap = slider.querySelector('[data-d367-showcase-dots]');
    if (!track || !dotsWrap) return;

    const getCardsPerPage = () => {
      if (window.innerWidth <= 767) {
        return Number(slider.dataset.cardsMobile || 1);
      }
      return Number(slider.dataset.cardsDesktop || 3);
    };

    const getCards = () => Array.from(track.querySelectorAll('.d367-variants-showcase__card'));

    const buildDots = () => {
      const cards = getCards();
      const perPage = Math.max(1, getCardsPerPage());
      const pageCount = Math.max(1, Math.ceil(cards.length / perPage));
      dotsWrap.innerHTML = '';

      for (let i = 0; i < pageCount; i += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'd367-showcase-dot';
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        dot.addEventListener('click', () => {
          track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
      }
    };

    const updateActiveDot = () => {
      const dots = Array.from(dotsWrap.querySelectorAll('.d367-showcase-dot'));
      if (!dots.length) return;
      const activeIndex = Math.min(
        dots.length - 1,
        Math.max(0, Math.round(track.scrollLeft / track.clientWidth))
      );
      dots.forEach((dot, idx) => dot.classList.toggle('is-active', idx === activeIndex));
    };

    buildDots();
    updateActiveDot();

    track.addEventListener('scroll', updateActiveDot);
    window.addEventListener('resize', () => {
      buildDots();
      updateActiveDot();
    });
  });

  /* ------------------ TESTIMONIALS ------------------ */
  document.querySelectorAll('[data-d367-testimonials]').forEach(wrapper => {
    const track = wrapper.querySelector('.d367-testimonials__track');
    const prev = wrapper.querySelector('.d367-testimonials__prev');
    const next = wrapper.querySelector('.d367-testimonials__next');
    if (!track || !prev || !next) return;

    const step = () => track.clientWidth * 0.9;

    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      prev.style.display = track.scrollLeft > 10 ? 'flex' : 'none';
      next.style.display = track.scrollLeft < max - 10 ? 'flex' : 'none';
    };

    prev.addEventListener('click', () =>
      track.scrollBy({ left: -step(), behavior: 'smooth' })
    );

    next.addEventListener('click', () =>
      track.scrollBy({ left: step(), behavior: 'smooth' })
    );

    track.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    setTimeout(update, 200);
  });

  /* ------------------ SERVING WAY (MOBILE ONLY) ------------------ */
  document.querySelectorAll('.d367-serve__grid').forEach(grid => {
    if (window.innerWidth > 768) return;

    grid.style.display = 'flex';
    grid.style.overflowX = 'auto';
    grid.style.scrollBehavior = 'smooth';
    grid.style.gap = '16px';

    grid.querySelectorAll('.d367-serve__card').forEach(card => {
      card.style.minWidth = '85%';
      card.style.flexShrink = '0';
    });
  });

  /* ------------------ Video Plan ------------------ */
document.querySelectorAll('[data-d367-video]').forEach(wrapper => {
    const playBtn = wrapper.querySelector('.d367-video-plan__play');
    const videoBox = wrapper.querySelector('.d367-video-plan__video');
    const placeholder = wrapper.querySelector('.d367-video-plan__placeholder');
    const iframe = wrapper.querySelector('iframe');

    if (!playBtn || !videoBox) return;

    playBtn.addEventListener('click', () => {
      playBtn.remove();
      if (placeholder) placeholder.remove();

      // Fix YouTube watch → embed
      if (iframe && iframe.dataset.embed) {
        let url = iframe.dataset.embed;

        if (url.includes('youtube.com/watch')) {
          const id = url.split('v=')[1];
          url = `https://www.youtube.com/embed/${id}?autoplay=1`;
        }

        if (url.includes('vimeo.com')) {
          const id = url.split('/').pop();
          url = `https://player.vimeo.com/video/${id}?autoplay=1`;
        }

        iframe.src = url;
      }

      videoBox.classList.remove('is-hidden');

      const video = videoBox.querySelector('video');
      if (video) video.play();
    });
  });

  // --------- faq ---------
      document.addEventListener('click', function (e) {
      const btn = e.target.closest('.d367-faq__question');
      if (!btn) return;

      const item = btn.closest('.d367-faq__item');
      const open = item.classList.contains('is-open');

      // Close all
      document.querySelectorAll('.d367-faq__item').forEach(i => {
        i.classList.remove('is-open');
        i.querySelector('.d367-faq__question').setAttribute('aria-expanded', 'false');
      });

      // Toggle current
      if (!open) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
    // serve__track code start
    document.querySelectorAll('[data-d367-serve]').forEach(wrapper => {
      const track = wrapper.querySelector('.d367-serve__track');
      const prev = wrapper.querySelector('.d367-serve__prev');
      const next = wrapper.querySelector('.d367-serve__next');

      if (!track || !prev || !next) return;

      const scrollStep = () => track.clientWidth * 0.9;

      const updateArrows = () => {
        const maxScroll = track.scrollWidth - track.clientWidth;

        if (maxScroll <= 5) {
          prev.classList.remove('is-visible');
          next.classList.remove('is-visible');
          return;
        }

        prev.classList.toggle('is-visible', track.scrollLeft > 5);
        next.classList.toggle('is-visible', track.scrollLeft < maxScroll - 5);
      };

      prev.addEventListener('click', e => {
        e.preventDefault();
        track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
      });

      next.addEventListener('click', e => {
        e.preventDefault();
        track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateArrows);
      window.addEventListener('resize', updateArrows);

      setTimeout(updateArrows, 200);
    });
    // serve__track end


  

(function () {
  'use strict';

  document.querySelectorAll('.d367-gallery').forEach(gallery => {

    const slides = gallery.querySelectorAll('.d367-slide');
    const thumbs = gallery.querySelectorAll('.d367-thumb');
    const thumbsWrap = gallery.querySelector('.d367-thumbs');

    function activate(index) {
      slides.forEach(s => s.classList.remove('is-active'));
      thumbs.forEach(t => t.classList.remove('is-active'));

      slides[index]?.classList.add('is-active');
      thumbs[index]?.classList.add('is-active');

      thumbs[index]?.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }

    /* THUMB CLICK */
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => activate(index));
    });

    /* ARROWS */
    gallery.querySelector('.d367-thumb-arrow.prev')
      ?.addEventListener('click', () => {
        thumbsWrap.scrollBy({ left: -120, behavior: 'smooth' });
      });

    gallery.querySelector('.d367-thumb-arrow.next')
      ?.addEventListener('click', () => {
        thumbsWrap.scrollBy({ left: 120, behavior: 'smooth' });
      });

    /* VARIANT CHANGE SUPPORT */
    document.addEventListener('variant:change', function (e) {
      const variant = e.detail.variant;
      if (!variant || !variant.featured_media) return;

      const mediaId = String(variant.featured_media.id);

      slides.forEach((slide, index) => {
        if (slide.dataset.mediaId === mediaId) {
          activate(index);
        }
      });
    });

    /* ===============================
      D367 ZOOM TOGGLE (2x)
    ================================ */
    document.addEventListener('click', function (e) {
      const zoomBtn = e.target.closest('.d367-zoom-btn');
      if (!zoomBtn) return;

      const wrap = zoomBtn.closest('.d367-zoom-wrap');
      if (!wrap) return;

      wrap.classList.toggle('is-zoomed');
    });


  });

})();


//  scroll top fix 
(function () {

  function scrollToTarget(id) {
    const target = document.getElementById(id);
    if (!target) return;

    const headerOffset = 100; // adjust if needed
    const y =
      target.getBoundingClientRect().top +
      window.pageYOffset -
      headerOffset;

    // lock scroll
    window.scrollTo(0, y);

    // reinforce scroll after theme JS runs
    setTimeout(() => window.scrollTo(0, y), 0);
    setTimeout(() => window.scrollTo(0, y), 50);
  }

  document.addEventListener('click', function (e) {
    const link = e.target.closest('.ctafeeding');
    if (!link) return;

    e.preventDefault();
    const id = link.getAttribute('data-target');
    scrollToTarget(id);
  });

})();

//

});




    document.addEventListener('click', function (e) {

      const btn = e.target.closest('.d367-product-description__toggle');

      if (!btn) return;

      const content = btn.parentElement.querySelector(
        '.d367-product-description__content'
      );

      const isOpen = content.classList.contains('is-open');

      content.classList.toggle('is-open');

      btn.textContent = isOpen ? 'Read More' : 'Show Less';

      btn.setAttribute(
        'aria-expanded',
        !isOpen
      );

    });

